import { Module } from 'src/domain';
import { useUpdateModuleInheritance } from 'src/hooks/split-levels/useUpdateModuleInheritance';

export const useCategorySplitUpdateInheritance = (standalone = false) =>
    useUpdateModuleInheritance(Module.CategorySplit, standalone);
